export default __webpack_public_path__ + "static/media/bo_note_D2.b581b7b5.svg";